import { type ReactNode, createContext, useContext } from "react";

export interface AuthTokenOptions {
	readonly skipCache?: boolean;
}

export type GetAuthToken = (options?: AuthTokenOptions) => Promise<string | null>;

const AuthTokenContext = createContext<GetAuthToken>(async () => null);

export function AuthTokenProvider({
	getToken,
	children,
}: {
	getToken: GetAuthToken;
	children: ReactNode;
}) {
	return <AuthTokenContext.Provider value={getToken}>{children}</AuthTokenContext.Provider>;
}

export function useGetAuthToken() {
	return useContext(AuthTokenContext);
}
